module.exports = __webpack_public_path__ + "img/kapcsolat_background-1360.e6dc4062.png";